namespace RedBullMOBILE360.SMSCodes {
    export interface ServiceSmsRow {
        Id?: number;
        ServiceName?: string;
        Code?: string;
        Endpoint?: string;
        XmlRequest?: string;
        SoapAction?: string;
        ReturnField?: string;
        ReturnNamespace?: string;
        ReturnMsgField?: string;
    }

    export namespace ServiceSmsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ServiceName';
        export const localTextPrefix = 'SMSCodes.ServiceSms';
        export const deletePermission = 'SMSCodes:ServiceSMS';
        export const insertPermission = 'SMSCodes:ServiceSMS';
        export const readPermission = 'SMSCodes:ServiceSMS';
        export const updatePermission = 'SMSCodes:ServiceSMS';

        export declare const enum Fields {
            Id = "Id",
            ServiceName = "ServiceName",
            Code = "Code",
            Endpoint = "Endpoint",
            XmlRequest = "XmlRequest",
            SoapAction = "SoapAction",
            ReturnField = "ReturnField",
            ReturnNamespace = "ReturnNamespace",
            ReturnMsgField = "ReturnMsgField"
        }
    }
}
